module.exports = __webpack_public_path__ + "img/tyree.984262fa.jpg";